<template>
  <div>
    <br />
    <br />
    <div class="footer">
      <div class="container">
        <div class="row">
          <div class="col-md-3">
            <router-link to="/" class="text-white">
              <h5 class="brand text-left text-white">
                freelance<strong>Projects</strong>
              </h5>
            </router-link>
            <div class="social-div float-left">
              <ul class="social-list">
                <li class="social-item">
                  <a
                    target="_blank"
                    class="link-icon"
                    href="https://github.com/mouadTaoussi"
                    ><i class="fab icons fa-github"></i
                  ></a>
                </li>
                <li class="social-item">
                  <a
                    target="_blank"
                    class="link-icon"
                    href="https://www.instagram.com/devmt_/"
                    ><i class="fab icons fa-instagram"></i
                  ></a>
                </li>
                <li class="social-item">
                  <a
                    target="_blank"
                    class="link-icon"
                    href="https://www.linkedin.com/mouad-taoussi-812b43173"
                    ><i class="fab icons fa-linkedin"></i
                  ></a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-4">
            <ul class="menu-list">
              <li class="menu-item"><p><strong style="font-size: 20px;!important">Company:</strong></p></li>
               <li class="menu-item">
                <router-link class="text-white" style="color: rgba(255,255,255,.8)!important" tag="p" to="/about"
                  >About</router-link
                >
              </li>
              <li class="menu-item"><p style="color: rgba(255,255,255,.8)!important">Privacy&Policy</p></li>
              <li class="menu-item"><p style="color: rgba(255,255,255,.8)!important">Terms&Conditions</p></li>
              <li class="menu-item"><p style="color: rgba(255,255,255,.8)!important">How it Works</p></li>
            </ul>
          </div>
          <div class="col-md-4">
            <ul class="menu-list">
              <li class="menu-item">
                <router-link class="text-white" style="font-size: 20px;!important" tag="strong" to="/login"
                  >Get into it!</router-link
                >
              </li>
              <li class="menu-item">
                <router-link class="text-white" style="color: rgba(255,255,255,.8)!important" tag="p" to="/login"
                  >Log in</router-link
                >
              </li>
              <li class="menu-item">
                <router-link class="text-white" style="color: rgba(255,255,255,.8)!important" tag="p" to="/register"
                  >Register</router-link
                >
              </li>
              <li class="menu-item">
                <router-link class="text-white" style="color: rgba(255,255,255,.8)!important" tag="p" to="/projects"
                  >Browse Projects</router-link
                >
              </li>
              <li class="menu-item">
                <router-link class="text-white" style="color: rgba(255,255,255,.8)!important" tag="p" to="/docs"
                  ><p>Api</p></router-link
                >
              </li>
            </ul>
          </div>
        </div>
        <!--  Basic Statistics (project counts && users counts)  -->
        <div class="float-left counts">
          <p class="inline mr-4 projects">
            Projects Posted:<strong
              style="font-weight:bolder!important;"
              class="ml-2"
              >{{ projects_posted }}</strong
            >
          </p>
           <p class="inline mr-4 projects">
            Projects Posted:<strong
              style="font-weight:bolder!important;"
              class="ml-2"
              >{{ projects_posted }}</strong
            >
          </p>
          <p class="inline mr-4 users">
            Freelancers & Employers:<strong
              style="font-weight:bolder!important;"
              class="ml-2"
              >{{ freelancers_employers }}</strong
            >
          </p>
        </div>
      </div>
    </div>
    <div class="sub-footer">
      <div class="container">
        <p class="text-white text-left">
          Made with <i class="fas fa-heart"></i> by Mouad Taoussi in
          <i class="fas mr-2 fa-home"></i>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
// IMPORT LINKS FILE
const link = require("../.././api.links.config.js");

export default {
  name: "footerApp",
  data() {
    return {
      projects_posted: "- - -",
      freelancers_employers: "- - -"
    };
  },
  created() {
    const gql = `
			  projects {
					_id 
					user_email 
					title 
					budget 
				}
				users {
					_id 
					name 
				}
			`;
    this.$http({
      url: link.baselink + `/graphql?query={${gql}}`,
      method: "get",
      headers: { "Content-Type": "application/json" }
    })
      .then(res => {
        this.projects_posted = res.data.data.projects.length;
        this.freelancers_employers = res.data.data.users.length;
      })
      .catch(err => {
        alert(err);
      });
  },
  methods: {}
};
</script>
<style scoped>
.footer {
  padding-top: 50px;
  background-color: rgba(0, 0, 0, 0.97);
  height: 350px;
  width: 100%;
  color: white;
  border-top: 8px solid var(--primary-color);
  font-weight: 100;
}
.inline {
  display: inline;
}
.sub-footer {
  background-color: black;
  height: 50px;
  padding-top: 10px;
  font-weight: 100 !important;
}
.menu-list {
  color: white;
  list-style: none;
  text-align: left;
  float: left !important;
  padding-left: 0 !important;
}
.menu-item {
  margin: 10px;
  cursor: pointer;
}
.social-div {
  margin-top: 40px;
  float: left !important;
}
.social-list {
  padding-left: 0 !important;
  list-style: none;
  color: black;
  padding-left: 0 !important;
}
.link-icon {
  color: black;
}
.icons {
  font-size: 25px;
  background-color: white;
  padding: 10px;
  border-radius: 50%;
}
.social-item {
  display: inline;
  margin-right: 10px;
}
.social-item:hover {
  background-color: black;
  color: white;
}
@media only screen and (max-width: 986px) {
  .footer {
    height: 100vh;
  }
  .sub-footer {
    height: 100px;
  }
  .menu-list {
    float: left;
  }
}
</style>
